import * as Types from '../../../../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type RejectCustomerMutationVariables = Types.Exact<{
  input: Types.RejectCustomerCommand;
}>;


export type RejectCustomerMutation = { __typename?: 'MutationModel', customers: { __typename?: 'CustomerMutationModel', rejectCustomer: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };


export const RejectCustomerDocument = gql`
    mutation RejectCustomer($input: RejectCustomerCommand!) {
  customers {
    rejectCustomer(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type RejectCustomerMutationFn = Apollo.MutationFunction<RejectCustomerMutation, RejectCustomerMutationVariables>;

/**
 * __useRejectCustomerMutation__
 *
 * To run a mutation, you first call `useRejectCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectCustomerMutation, { data, loading, error }] = useRejectCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectCustomerMutation(baseOptions?: Apollo.MutationHookOptions<RejectCustomerMutation, RejectCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectCustomerMutation, RejectCustomerMutationVariables>(RejectCustomerDocument, options);
      }
export type RejectCustomerMutationHookResult = ReturnType<typeof useRejectCustomerMutation>;
export type RejectCustomerMutationResult = Apollo.MutationResult<RejectCustomerMutation>;
export type RejectCustomerMutationOptions = Apollo.BaseMutationOptions<RejectCustomerMutation, RejectCustomerMutationVariables>;